import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../classes/user';
import { BaseService } from './base.service';
import { FilterSponsor } from '../classes/filterCrest';

@Injectable({
    providedIn: 'root',
  })
  export class SponsorService extends BaseService{
    constructor(http: HttpClient){
        super(http);
        this.entity = 'crest';
    }

  private filterObs$: BehaviorSubject<FilterSponsor> = new BehaviorSubject(new FilterSponsor());
    getFilterObs(): Observable<FilterSponsor> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterSponsor) {
          this.filterObs$.next(filter);
    }

  }